<template>
  <svg :width="width" :height="height" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path
      d="M17 48V11.9818C17 8.12587 20.1259 5 23.9818 5H73.0182C76.8741 5 80 8.12587 80 11.9818V48"
      stroke="#05070F"
      stroke-width="2"
    />
    <path
      d="M16.0027 32C16.0027 32 9.49868 35 5.00271 38C2.49868 39.5 2.00271 41 2.00271 44C1.99896 45 2.00241 83 2.00271 86.5C2.00263 90.5 4.5 93 10.0027 94C17 94 78 94 87.0027 94C94.0027 93 93.5 90.5 94.0027 86C94.0027 83 94.0027 53.5 94.0027 45C94 41 92.326 39.0479 90.0027 37.5C85.5 34.5 81.5027 33 81.5027 33"
      stroke="#05070F"
      stroke-width="2"
    />
    <path
      d="M86.5 44.5C86.5 44.5 58.5 60 54 62.5C49.2516 65.138 47 65.119 42 62.5C31.5 57 10 44.5 10 44.5"
      stroke="#05070F"
      stroke-width="2"
      stroke-linecap="round"
    />
    <path d="M64.5 68L85 85.5" stroke="#05070F" stroke-width="2" stroke-linecap="round" />
    <path d="M29.5 68L9 85.5" stroke="#05070F" stroke-width="2" stroke-linecap="round" />
    <path
      d="M41.1776 29.0747C41.7285 28.6092 42.5699 28.6585 43.0571 29.1848L45.4247 31.743L53.2773 24.0045C53.7892 23.5 54.6321 23.4876 55.16 23.9768C55.6879 24.466 55.7009 25.2715 55.189 25.776L45.3348 35.4869L41.0624 30.8707C40.5752 30.3444 40.6268 29.5403 41.1776 29.0747Z"
      fill="#FF0064"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M48.001 45.436C39.1644 45.436 32.001 38.2726 32.001 29.436C32.001 20.5995 39.1644 13.436 48.001 13.436C56.8375 13.436 64.001 20.5995 64.001 29.436C64.001 38.2726 56.8375 45.436 48.001 45.436ZM48.001 42.5269C55.2309 42.5269 61.0919 36.6659 61.0919 29.436C61.0919 22.2061 55.2309 16.3451 48.001 16.3451C40.7711 16.3451 34.9101 22.2061 34.9101 29.436C34.9101 36.6659 40.7711 42.5269 48.001 42.5269Z"
      fill="#FF0064"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'EmailConfirmedIllustration',
  props: {
    width: {
      type: Number,
      default: 96,
    },
    height: {
      type: Number,
      default: 96,
    },
  },
};
</script>
